import { FormikProps } from 'formik'
import get from 'lodash/get'

import { Address, Output, RistProfile } from 'common/api/v1/types'
import { Select, PerformantTextInput } from '../../../../common/Form'
import { createDefaultFiledValues, makeAddressOptions } from '../../../../../utils'

export enum RistFields {
  profile = 'profile',
  sourceAddress = 'sourceAddress',
  address = 'address',
  port = 'port',
}

export const ristDefaults = () => createDefaultFiledValues(Object.keys(RistFields), [])
export const getRistFieldsToSave = () => Object.keys(RistFields)

interface RistFormProps {
  form: FormikProps<Output>
  addresses: Array<Address>
  namePrefix: string
}
const RistForm = ({ form: { values }, namePrefix, addresses }: RistFormProps) => {
  const sourceAddressSelector = `${namePrefix}.${RistFields.sourceAddress}`
  const selectedSourceAddress = get(values, sourceAddressSelector)
  const addressesAndEmptyAddress = [{ address: '', netmask: '' }, ...addresses]
  const addressOptions = [{ name: 'any', value: '' }, ...makeAddressOptions(selectedSourceAddress, addresses)]
  return (
    <>
      <Select name={`${namePrefix}.${RistFields.profile}`} label="Profile" options={[RistProfile.simple]} required />
      <Select
        name={sourceAddressSelector}
        label="Source Address"
        options={addressOptions}
        newLine
        validators={{
          addressIn: { addresses: addressesAndEmptyAddress },
        }}
      />
      <PerformantTextInput
        name={`${namePrefix}.${RistFields.address}`}
        label="Destination address"
        required
        validators={{ ip: {} }}
        type="text"
        newLine
      />
      <PerformantTextInput
        name={`${namePrefix}.${RistFields.port}`}
        label="Destination Port"
        required
        type="number"
        noNegative
        validators={{
          port: { even: true, isUdp: true },
        }}
      />
    </>
  )
}

export default RistForm
